module.exports = __webpack_public_path__ + "static/media/Project3_Fig26.88eb6a47.png";